import React from 'react';
import ReactDOM from 'react-dom/client';
import './responsive.css';
import { initSentry, Sentry } from './sentry';
import App from './App';

// Initialise Sentry as early as possible
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

function ErrorFallback() {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh', background: '#080a0f', color: '#e4e8f0',
      fontFamily: "'Outfit', -apple-system, sans-serif", padding: 24, textAlign: 'center',
    }}>
      <div style={{ maxWidth: 480 }}>
        <div style={{ fontSize: 42, marginBottom: 12 }}>⚠️</div>
        <h1 style={{ fontSize: 22, margin: '0 0 12px' }}>Something went wrong</h1>
        <p style={{ color: '#95a5c0', lineHeight: 1.6, marginBottom: 20 }}>
          An unexpected error occurred and our team has been notified.
          You can try reloading the page or go back to the dashboard.
        </p>
        <button onClick={() => window.location.reload()} style={{
          padding: '10px 22px', borderRadius: 8, background: '#4a58e5', color: '#fff',
          border: 'none', fontSize: 14, fontWeight: 600, cursor: 'pointer', marginRight: 8,
        }}>Reload</button>
        <a href="/" style={{
          display: 'inline-block', padding: '10px 22px', borderRadius: 8,
          background: 'transparent', color: '#97a6ff', border: '1px solid #4a58e5',
          fontSize: 14, fontWeight: 600, textDecoration: 'none',
        }}>Go to dashboard</a>
      </div>
    </div>
  );
}
